{
  "monacoEditor": {
    "noHistoryData": "В истории нет записей",
    "currentValue": "Текущее значение",
    "addToCompare": "Добавить в список для сравнения",
    "reloadConfig": "Обновить конфигурацию",
    "goToCompare": "Перейти в режим сравнения"
  },
  "compareDialog": {
    "title": "Сравнение значений атрибутов",
    "base": "Базовое",
    "compared": "Сравниваемое",
    "cit": "ТКЕ",
    "ci": "КЕ",
    "attribute": "Атрибут",
    "changedAt": "Время изменения",
    "search": "Поиск",
    "searchPlaceholder": "Поиск...",
    "sideView": "Side",
    "inlineView": "Inline",
    "onlyChanges": "Только изменения",
    "unchangedLines": "$ неизменённых строк",
    "changes": "Различий",
    "changedLines": "Изменено строк",
    "diffMetadata": "Метаданные diff",
    "ciId": "CI id",
    "validUntil": "Действует до",
    "exportDiff": "Экспорт diff"
  },
  "assignUser": {
    "assignAt": "Назначить на",
    "assign": "Назначенный",
    "none": "Не назначен"
  }
}